import {language_EN} from '../../lang/en'
import {language_ES} from '../../lang/es'
class LanguageFactory {

    private lang_dictionaries: {[key: string]: any}
    private language: String | undefined

    constructor (lang?: string) {
        this.lang_dictionaries = {
            'en': language_EN,
            'es': language_ES
        }
        this.language = lang
    }

    setLanguage(lang: string) {
        this.language = lang
    }

    getLanguage() { return this.language }

    getLanguages() {
        return Object.keys(this.lang_dictionaries)
    }

    translate(lang:string, key:string) {        
        const dictionary = this.lang_dictionaries[lang]
        if (dictionary === null || dictionary === undefined) {
            return `the following ${lang} language is not setted`
        }
        return dictionary[key] || `unavailable "${key}" translation`
    }

    registerLanguage(key:string, dictionary: object) {
        this.lang_dictionaries[key] = dictionary
    }

}

class TextValidator {
    private text: string
    public maxLength: number | undefined

    constructor(text: string, maxLength?: number) {
        this.text = text
        this.maxLength = maxLength
    }

    validateMaxLength() { 
        if (this.text !== null && this.maxLength) {
            return !(this.text?.length <= this.maxLength)
        }
        return false
    }
}

class ErrorValidator extends TextValidator {
    maxLengthError() {
        if (this.validateMaxLength())
            return (`You have reached the max length of ${this.maxLength}`)
        return 'This field is required'
    }
}

export { 
    LanguageFactory,
    TextValidator,
    ErrorValidator 
}
